import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  num: '1',
  title: 'Farmacia en Macetas',
  desc: 'Aprende a cultivar tus propios remedios en casa, sin importar si tienes patio o solo una ventana pequeña.'
}, {
  num: '2',
  title: 'Medicina en la Cocina',
  desc: 'Transforma tus comidas diarias en poderosos tratamientos naturales para desinflamar y fortalecer tu cuerpo.'
}, {
  num: '3',
  title: 'Protocolo Detox 7 Días',
  desc: 'El paso a paso exacto para limpiar tu hígado, riñones y colon de toxinas acumuladas en solo una semana.'
}, {
  num: '4',
  title: 'Guía de Elixires Rápidos',
  desc: 'Preparaciones de emergencia para aliviar dolores de cabeza, insomnio y mala digestión en menos de 15 minutos.'
}, {
  num: '5',
  title: 'Glosario de Enfermedades A-Z',
  desc: 'Encuentra al instante la planta y la dosis exacta para cada síntoma. Directo, rápido y práctico.'
}, {
  num: '6',
  title: 'Guía de Conservación',
  desc: 'Domina el arte de secar y guardar tus hierbas para que duren años sin perder su poder curativo.'
}];
export function BonusSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-paper-soft relative overflow-hidden" data-id="element-18">
      <div className="max-w-2xl mx-auto relative z-10" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5 sm:mb-8 flex flex-col items-center" data-id="element-20">
          <div className="bg-brand-terracotta/20 p-3 rounded-full mb-3" data-id="element-21">
            <GiftIcon className="w-7 h-7 sm:w-8 sm:h-8 text-brand-terracotta" data-id="element-22" />
          </div>
          <h2 className="text-lg sm:text-2xl font-serif font-bold text-brand-forest mb-2 leading-tight" data-id="element-23">
            Si ordenas hoy el Manual Maestro, te llevas estos 6 complementos de
            forma totalmente GRATUITA:
          </h2>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-24">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white border border-brand-terracotta/30 p-4 sm:p-5 rounded-xl shadow-sm" data-id="element-25">
              <div className="flex items-center gap-2 mb-2" data-id="element-26">
                <span className="text-brand-terracotta font-black text-xs tracking-widest" data-id="element-27">
                  🎁 BONUS {bonus.num}
                </span>
                <span className="text-brand-muted/40" data-id="element-28">|</span>
                <span className="text-xs font-black text-brand-terracotta uppercase" data-id="element-29">
                  GRATIS
                </span>
              </div>
              <h3 className="text-sm sm:text-base font-bold text-brand-forest leading-tight mb-1" data-id="element-30">
                {bonus.title}
              </h3>
              <p className="text-xs sm:text-sm text-brand-muted font-medium leading-snug" data-id="element-31">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Urgency warning */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 sm:mt-8 bg-brand-forest text-brand-paper rounded-xl p-4 sm:p-5 flex gap-3 items-start border border-brand-terracotta/50" data-id="element-32">
          <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-brand-terracotta-light shrink-0 mt-0.5" data-id="element-33" />
          <p className="text-xs sm:text-sm font-medium leading-snug" data-id="element-34">
            <strong className="uppercase text-brand-terracotta-light" data-id="element-35">
              ⚠️ Importante:
            </strong>{' '}
            Esta oferta con los 6 Bonos Gratis y el 50% de descuento está
            disponible solo para los próximos{' '}
            <strong className="text-brand-terracotta-light" data-id="element-36">500 cupos</strong> o
            hasta que el contador llegue a cero.
          </p>
        </motion.div>

        {/* Mid-page persuasive CTA — the extra button user requested */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 sm:mt-8 text-center" data-id="element-37">
          <p className="text-sm sm:text-base font-bold text-brand-forest mb-3 italic" data-id="element-38">
            No pierdas la oportunidad de obtener el Sistema Completo por el
            precio de una sola cena.
          </p>
          <CTAButton variant="primary" className="w-full sm:w-auto sm:min-w-[320px]" data-id="element-39">
            🌿 SÍ, RECLAMO MIS 6 BONOS GRATIS AHORA
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}